<script setup lang="ts"></script>

<template>
  <div class="context-menu-content">
    <slot />
  </div>
</template>

<style scoped lang="scss">
.context-menu-content {
  display: grid;
  padding: 8px 0;
  gap: 8px;
}
</style>
